<template>
  <div class="layout--default">
    <div id="top">
      <div class="title-wrap">
        <div class="nav-btn" @click="toggleNav">
          <fa :icon="['fas','bars']" size="lg"/>
        </div>
        <div class="icon">
            <img :src="`/${$conf.NAMESPACE}/${$conf.CURRENT_PROFILE}/banner.png`" onerror="this.style.display='none'"/>
        </div>
        <div class="title">EV Portal</div>
      </div>
      <div class="action-btn">
        <div class="name-wrap">
          <div class="greeting">{{ $t("label.greeting") }}</div>
          <div v-if="permissions.includes(`read_user_profile`.toUpperCase())" @click="go('user/profile')" class="wrap pointer">
            <div class="role">{{ usr_max_role.name }}</div>
            <div class="name">{{ username }}</div>
          </div>
          <div v-else class="wrap">
            <div class="role">{{ usr_max_role.name }}</div>
            <div class="name">{{ username }}</div>
          </div>
        </div>
        <el-button type="info" @click="logout" size="mini">{{ $t("label.logout") }}</el-button>
      </div>
    </div>
    <div id="main">
      <div id="nav" v-loading="!ready">
        <!-- <router-link v-for="page in Object.keys($setting.crud)" :key="page" :to="page">{{ page }}</router-link> |       -->
        <Sidebar ref="sidebar"/>
      </div>
      <div class="content-wrap">
        <div id="content" v-loading="!ready || load">
          <router-view :key="$route.fullPath" v-if="ready"/>
        </div>
        <div class="footer">
          <div class="version-wrap">
            <div class="label">API</div>
            (<div class="ver">{{ version.api }}</div>)
          </div>
          <div class="version-wrap">
            <div class="label">Web</div>
            (<div class="ver">{{ version.web }}</div>)
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/layouts/Sidebar";
import { mapState } from 'vuex';

export default {
  components: {
    Sidebar
  },
  beforeMount() {
    this.$store.dispatch("data/fetchVersionApi");
  },
  methods: {
    logout() {
      this.$confirm(this.$t("message.logout_warning"), this.$t("label.logout"), {
        confirmButtonText: this.$t("label.logout"),
        cancelButtonText: this.$t("button.cancel"),
        type: 'warning'
      }).then(async () => {
        await this.$axios.post(`logout`).catch(err=>err);
        localStorage.removeItem("lt");
        this.$axios.defaults.headers.common["Authorization"] = "";
        this.go("login");
      });
    },
    toggleNav() {
      // console.log("toggle in default layout");
      // this.$refs.sidebar.toggleNav();
      this.$store.commit("control/setSidebar", !this.sidebar);
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.user.user_info.permissions,
      username: state => state.user.user_info.name,
      roles: state => state.user.user_info.roles,
      sidebar: state => state.control.sidebar,
      ready: state => state.status.ready,
      load: state => state.control.load,
      version: state => state.data.version
    }),
    usr_max_role() {
      let role = {};
      this.roles.map(r=>{
        if(typeof role.level != "undefined") {
          if(r.level > role.level) {
            role = r;
          }
        }else{
          role = r;
        }
      });
      return role;
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss">
.layout--default{
  min-height: 100%;
  display: flex;
  flex-direction: column;
  #top{
    height: 35px;
    border: solid 1px #e6e6e6;
    background: var(--nav-header-bg);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px 0 0;
    .title-wrap{
      display: flex;
      align-items: center;
      .nav-btn{
        // padding: 10px 20px;
        height: 35px;
        width: 55px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .icon{
        height: 20px;
        img{
          height: 100%;
        }
      }
      .title{
        margin-left: 10px;
        margin-bottom: 3px;
        font-size: large;
      }
    }
    .action-btn{
      display: flex;
      .name-wrap{
        font-size: 13px;
        margin-right: 20px;
        display: flex;
        align-items: center;
        .greeting{
          // height: 100%;
          // display: flex;
          // flex-direction: column;
          // justify-content: flex-end;
        }
        .wrap{
          &.pointer{
            cursor: pointer;
            color: -webkit-link;
            text-decoration: underline;
          }
          line-height: 1.1em;
          .role{
            font-size: 10px;
            zoom: .9;
          }
          .name{
            text-align: center;
          }
        }
      }
    }
  }
  #main{
    display: flex;
    flex-grow: 1;
    & > .content-wrap{
      height: calc(100vh - 39px);
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      overflow: hidden;
      #content{
        // height: calc(100vh - 80px);
        flex-grow: 1;
        border: 1px solid  var(--layout-border-color);
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        overflow-x: hidden;
        &>*{
          padding: 10px;
          flex-grow: 1;
          // overflow-y: auto;
        }
      }
      & > .footer{
        height: 20px;
        display: flex;
        padding: 0 20px;
        justify-content: flex-end;
        .version-wrap{
          display: flex;
          font-size: 12px;
          .label,
          .ver{
            display: flex;
            align-items: center;
          }
          .label{
            margin-right: 2px;
          }
          .ver{
            font-weight: bold;
          }
          &:not(:last-child) {
            margin-right: 15px;
          }
        }
      }
    }
  }
}
</style>
